module.exports = __webpack_public_path__ + "static/media/buildingConstruction0.22331f3e.jpeg";